{
  "version": 1,
  "asset_id": "2cbc7484-2c21-4276-a03f-a183ae0d49d0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2cbc7484-2c21-4276-a03f-a183ae0d49d0/band-erosion-egd-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2cbc7484-2c21-4276-a03f-a183ae0d49d0/band-erosion-egd-800.webp",
  "original_filename": "band-erosion-egd-800.webp",
  "size": 86268,
  "content_type": "image/webp",
  "created_at": "2026-11-02T10:46:20Z"
}
